<div class="single-slider">
  @if (filter.sliderOptions && filter.sliderOptions.title) {
    <div class="single-slider__slider-title">
      {{sliderTitle || filter.sliderOptions.title}}
    </div>
  }
  <ngx-slider [(value)]="filter.sliderOptions.value"
    [options]="filter.sliderOptions"
    (valueChange)="updateSliderTitle($event, filter.sliderOptions)"
    (userChangeEnd)="updateSliderValue($event.value, filter)">
  </ngx-slider>
</div>